import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.Contract.PricingInfo.IParams;
type Request = Api.Core.Contract.PricingInfo.IRequest;
type Response = Api.Core.Contract.PricingInfo.IResponse;
type Headers = Api.Core.Contract.PricingInfo.IHeaders;
const url = '/api/Sales/Contract/pricingInfo/:dealerId/:distributorId';
export default async function contractPricingInfoApi(params: Params, body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params, null),
    body,
    headers: getDefaultHeaders(),
  });
}
